import { render, staticRenderFns } from "./GameLounge.vue?vue&type=template&id=210928eb&scoped=true&"
import script from "./GameLounge.vue?vue&type=script&lang=js&"
export * from "./GameLounge.vue?vue&type=script&lang=js&"
import style0 from "./GameLounge.vue?vue&type=style&index=0&id=210928eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210928eb",
  null
  
)

export default component.exports